import React from 'react';
import { useTheme, Era } from '../contexts/ThemeContext';
export function ThemeSwitcher() {
  const {
    currentEra,
    setCurrentEra
  } = useTheme();
  const handleEraChange = (era: Era) => {
    setCurrentEra(era);
  };
  return <div className="fixed bottom-4 right-4 z-50 bg-white p-2 rounded shadow-lg" data-id="element-229">
      <div className="flex flex-col space-y-2" data-id="element-230">
        <button onClick={() => handleEraChange('60s')} className={`px-2 py-1 text-xs font-bold ${currentEra === '60s' ? 'bg-black text-white' : 'bg-gray-200'}`} data-id="element-231">
          60s
        </button>
        <button onClick={() => handleEraChange('70s')} className={`px-2 py-1 text-xs font-bold ${currentEra === '70s' ? 'bg-amber-800 text-white' : 'bg-gray-200'}`} data-id="element-232">
          70s
        </button>
        <button onClick={() => handleEraChange('80s')} className={`px-2 py-1 text-xs font-bold ${currentEra === '80s' ? 'bg-indigo-900 text-white' : 'bg-gray-200'}`} data-id="element-233">
          80s
        </button>
        <button onClick={() => handleEraChange('90s')} className={`px-2 py-1 text-xs font-bold ${currentEra === '90s' ? 'bg-gray-900 text-white' : 'bg-gray-200'}`} data-id="element-234">
          90s
        </button>
        <button onClick={() => handleEraChange('2000s')} className={`px-2 py-1 text-xs font-bold ${currentEra === '2000s' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`} data-id="element-235">
          00s
        </button>
      </div>
    </div>;
}